import React, { ForwardedRef, forwardRef, memo } from "react";
import { IOrder } from "../../../../../../types/driver";
import { Box } from "@mui/material";
import FreightCard from "../FreightCard";
import LoadingBox from "../../../../../components/LoadingBox";

interface Props {
  orders: IOrder[];
  pagN: number;
  nextPageLoading: boolean;
}

const OrdersList = memo(
  forwardRef((props: Props, ref: ForwardedRef<HTMLDivElement>) => {
    const { orders, pagN, nextPageLoading } = props;

    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          paddingX: "8px",
          paddingBottom: "70px",
        }}
      >
        {orders?.map((item: IOrder, index) => (
          <>
            <FreightCard
              index={index + 1}
              ref={index + 1 === pagN * 30 ? ref : null}
              key={item.id}
              {...item}
            />
            {index === orders.length - 1 && nextPageLoading && <LoadingBox />}
          </>
        ))}
      </Box>
    );
  })
);

export default OrdersList;
